// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a6a35460","879":"1f80c7fb"}[chunkId] + ".chunk.js";
};